<template>
  <div class="Hero">
    <HeaderBar />
    <div class="Hero__title-container container">
      <div class="tagline">
        <h2 class="cd-headline rotate-1">
            <span class="static">Art</span>
            <span class="cd-words-wrapper">
                <b class="is-visible-anim">Transplant</b>
                <b>Installation</b>
                <b>Framing</b>
                <b>Security</b>
            </span>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../components/HeaderBar.vue';
import animatedHeadlines from '../js/animated-headlines';

export default {
    name: 'Hero',
    props: {},
    components: {
        HeaderBar,
    },
    mounted () {
        animatedHeadlines();        
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Hero {
    height: 400px;
    background-image: url('../assets/images/banner.jpg');
    background-size: cover;
    background-repeat: no-repeat;

    @media screen and (min-width: 768px) {
        height: 600px;
    }

    @media screen and (min-width: 1088px) {
        height: 800px;
    }

    &__title-container {
        height: 100%;
        position: relative;
    }
    .tagline {
        color: white;
        top: 40%;
        position: absolute;
        left: 20px;
        @media screen and (min-width: 768px) {
            left: 0;
        }
        
        h2 {
            color: white;
            font-size: 3em;
            margin-bottom: 20px;
            margin-top: 0;
            text-align: left;
            @media screen and (min-width: 768px) {
                font-size: 6em;
            }
        }
        
        .static {
            font-size: 0.8em;
            display: block;
            line-height: 1.25em;
            margin-left: 8px;
        }
        
        
    }
}
</style>
